module.exports = __webpack_public_path__ + "img/logo-s.99a68f16.svg";